import type { SignalSource } from '../../../../shared/enums';
import { shell } from '../../app';
import { runSourceNow } from '../../data/signals';
import { SOURCE_NAMES } from '../../logic/signals';
import type { SourceRows } from '../../logic/sourceHealth';
import { h } from '../../ui/dom';
import { sheetDialogs, sourcesSheet } from '../signals/sourcesSheet';
import type { GoogleUsage } from '../signals/sourcesSheet';

/** A source read at the rep's word (D77): the server answers at once and reads on; the sheet is read
 *  again when the read has had a moment. */
const RUN_NOW_RELOAD_MS = 20_000;

/** The right side of the desktop New businesses with none picked (D66, D74): a hint, then the sources
 *  sheet, its dialogs — the bookmark setup, a city upload — opening over the page. Repainted only when
 *  the sources changed, so a fold stays as the rep left it. */
export const deskSources = (on: { refresh: () => void; imported: () => void }) => {
  const dialogs = sheetDialogs(on.imported);
  let reload: ReturnType<typeof setTimeout> | null = null;
  const runNow = (source: SignalSource | 'places_retention') =>
    void runSourceNow(source)
      .then(() => {
        shell.toast(`Reading ${(source === 'places_retention' ? 'Google cache retention' : SOURCE_NAMES[source])}…`);
        if (reload) clearTimeout(reload);
        reload = setTimeout(on.refresh, RUN_NOW_RELOAD_MS);
      })
      .catch((err: unknown) =>
        shell.toast(err instanceof Error ? err.message : `Could not read ${(source === 'places_retention' ? 'Google cache retention' : SOURCE_NAMES[source])} now.`, {
          kind: 'error',
        }),
      );
  const sheet = sourcesSheet({ refresh: on.refresh, runNow, ...dialogs.actions });
  const el = h(
    'div',
    { class: 'sig-deskside' },
    h('p', { class: 'sig-deskside__hint' }, 'Pick a business on the left to see it here.'),
    sheet.el,
  );
  let painted: { rows: SourceRows; at: string | null; google: GoogleUsage | undefined } | null = null;
  const update = (rows: SourceRows | null, updatedAt: string | null, google?: GoogleUsage) => {
    if (!rows || (painted && painted.rows === rows && painted.at === updatedAt && painted.google === google))
      return;
    painted = { rows, at: updatedAt, google };
    sheet.update(rows, updatedAt, google);
  };
  return {
    el,
    update,
    dispose: () => {
      if (reload) clearTimeout(reload);
      dialogs.remove();
    },
  };
};
